var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top'),_vm._v(" "),_c('banners'),_vm._v(" "),_c('mxzc'),_vm._v(" "),_c('mxfw'),_vm._v(" "),_c('mxsyssb'),_vm._v(" "),_c('bottom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-204446c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Statistics/statistics.vue
// module id = null
// module chunks = 